import { CurrentPageType, NextSurveyItemType, PaginationState } from './types';

export const isFirstSurveyItem = (state: PaginationState) =>
  state.pageHistory.findIndex(({ surveyItemId }) => surveyItemId === state.currentSurveyItem) === 0 ||
  !state.pageHistory.length;

type GetNextSurveyItemType = (state: PaginationState) => NextSurveyItemType;

export const getNextSurveyItem: GetNextSurveyItemType = (state) => {
  const currentIndex = state.pageHistory.findIndex(({ surveyItemId }) => surveyItemId === state.currentSurveyItem);
  if (currentIndex < 0) return { sectionId: state.currentSection, surveyItemId: state.currentSurveyItem };

  const nextIndex = currentIndex + 1;
  const pageHistoryItem = state.pageHistory.at(nextIndex);

  if (!pageHistoryItem) return { sectionId: state.currentSection, surveyItemId: state.currentSurveyItem };

  return pageHistoryItem;
};

type GetPreviousAnswerType = (
  state: PaginationState,
  backOnFirstSurveyItem: (() => void) | undefined
) => CurrentPageType;

export const getPreviousSurveyItem: GetPreviousAnswerType = (state, backOnFirstSurveyItem) => {
  const currentIndex = state.pageHistory.findIndex(({ surveyItemId }) => surveyItemId === state.currentSurveyItem);

  if (isFirstSurveyItem(state)) {
    if (backOnFirstSurveyItem) backOnFirstSurveyItem();
    return state;
  }

  const previousIndex = currentIndex > 0 ? currentIndex - 1 : -1;
  const pageHistoryItem = state.pageHistory.at(previousIndex);

  if (!pageHistoryItem) return state;

  const { surveyItemId: currentSurveyItem, sectionId: currentSection } = pageHistoryItem;

  return { currentSurveyItem, currentSection };
};
